export default "__VITE_ASSET__BRdJhxx5__"